import { render, staticRenderFns } from "./ReportCreate.vue?vue&type=template&id=882f28aa&"
import script from "./ReportCreate.vue?vue&type=script&lang=js&"
export * from "./ReportCreate.vue?vue&type=script&lang=js&"
import style0 from "./ReportCreate.vue?vue&type=style&index=0&id=882f28aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports